<script>
	import { quantity, method, postal, shipping } from './store.js'
	import en from "../strings.en"
	import fr from "../strings.fr"
	import { getCookie, setCookie, openProductLocator} from "./utilities"
	import Portal from 'svelte-portal'

	export let productCode, lang, dataset, availabilityData, price, buyabilityDataLayer=false
	// console.log('Shipping Svelte Availability Data', availabilityData)
	// $: $quantity, checkMaxQuanityPerFulfillmentType(), setDestPostalCodeAndCalculateShipping();
    let timer
    const debounce = (func) => {
        clearTimeout(timer)
        timer = setTimeout(()=> {
            func()
        }, 500)
    }
    $:if( $quantity && (availabilityData?.codes.includes('IN_STOCK_ONLINE') || availabilityData?.codes.includes('SHIP_TO_HOME_ONLY'))) {
        shippingCostLoader = true, shippingMsgType = '', disableShipToHome = false, noRatesReturned = false 
        debounce(setDestPostalCodeAndCalculateShipping);
        checkMaxQuanityPerFulfillmentType();
    } else if( $quantity) {
        checkMaxQuanityPerFulfillmentType();
    }
    // $: console.log('method:', $method)
	let productName = dataset.productName || false
	let productBrand = dataset.productBrand || false
	let onlineOnlyProduct = (dataset?.productOnlineOnly?.toString() == 'true' ? true : false) || false
	let preferredStore = JSON.parse(localStorage.getItem("preferredStore"));
	let preferredStorePostalCode = preferredStore.address.postalOrZipCode;
    let nearestWarehouseAddr = "";
    let destAddr = "";
	let origPostalCode = "";
	let destPostalCode = "";
	let isOverweightOrOversized = false;
	let shippingCostLoader = false;
	let shippingRates = 0;
	let shippingTimeline = 0;
	let invalidPostalCodeError = false;
	let invalidPostalCodeFormatError = false;
	let showPostalUI = false
	let strings = en;
	let nearestWarehouses = [];
	if(lang =='fr'){
		strings = fr;
	}
	let _strings = strings.strings;
	let fulFillmentTypeQuantity = 0;
	let otherFulFillmentTypeQuantity = 0;
	let disableStorePickup = false;
	let disableShipToHome = false;
	let shippingThreshold = false;
	let freeShipping = false;
	let effectivePrice = price.salePrice ? price.salePrice : price.price
    let unAvailPostal = ''
    let shippingMsgType = ''
    let miscShippingCharges = 0
    let noRatesReturned = false;
    let shippingStatus = false;
	let showShipToStoreUI = false;
	let estShippingTimeline = {};
	let bufferTime = 0 ;
	let nearestWarehouseLat = '';
	let nearestWarehouseLng = '';
	let prevQuantity = 0;
	let destinationCoords = {}
	let changedPostal = true;
	let lowStockWarning = false

    $:{
        if(shippingCostLoader){
            shippingStatus = 'loading'
        }else if(!shippingCostLoader && noRatesReturned) {
            shippingStatus = 'No Rates'
        }else {
            shippingStatus = true
        }
        // console.log('shippingStatus:', shippingStatus)
    }

    let fetchPickupTimelines = false;
    let fetchTimelineLoader = false;


    const togglePostalUI = () => {
		showPostalUI = !showPostalUI ? true : false;
		setDestPostalCodeAndCalculateShipping();
        if(!disableShipToHome && !invalidPostalCodeError){
            document.getElementById("shipToHome").checked = true;
            $method = 'Ship';
        } 
	}

	const toggleShipToStoreUI = () => {
		showShipToStoreUI = !showShipToStoreUI;
	}

    /** DC fulfillment timelines */
    async function dcFullfillmentTimelines() {
        try{
            fetchTimelineLoader = true;
            let isItemInStock = availabilityData?.inventory?.store &&  availabilityData?.inventory?.store > 0 ? true : false
            if(availabilityData?.inventory?.actualStoreStock) {
                isItemInStock = availabilityData?.inventory?.actualStoreStock &&  availabilityData?.inventory?.actualStoreStock > 0 ? true : false
            }
			let bopisTimeLineUrl = new URL(`https://delivery-data.homehardware.workers.dev/${preferredStore?.code}?nrti=${availabilityData?.debug?.storeNRTI}&instock=${isItemInStock}`)
			if(availabilityData?.codes.includes('BUYABLE_NON_ECOM')) {
				bopisTimeLineUrl.searchParams.append('storeonly', true)
			}
            fetchPickupTimelines = await fetch(bopisTimeLineUrl.href, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                }              
            })
            fetchPickupTimelines = await fetchPickupTimelines.json();
            fetchTimelineLoader = false;
            if(buyabilityDataLayer) {
                buyabilityDataLayer.data.bopisTimeline = `${fetchPickupTimelines?.Least}-${fetchPickupTimelines?.Most} days` 
                window.dataLayer.push(buyabilityDataLayer)
            }
            // console.log('fetchPickupTimelines', fetchPickupTimelines)
        } catch(err) {
            console.warn(err)
            fetchPickupTimelines = false;
            fetchTimelineLoader = false;
        }
    }

	function updatepreferredStorePostalCode() {
		preferredStore = JSON.parse(localStorage.getItem("preferredStore"));
		preferredStorePostalCode = preferredStore.address.postalOrZipCode;
	}

	//check if postal code is valid that is not null, length = 6 and meets the given regex condition.
	function isPostalCodeValid(postalCode) {
		if (
			postalCode != null &&
			postalCode != "" &&
			postalCode.length === 6 &&
			/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i.test(
				postalCode
			)
		) {
			return true;
		} else {
			return false;
		}
	}

	async function updateNearestWarehouses() {		
		try {
			if (productCode && destPostalCode) {
				const response = await fetch(`/_data/${lang}/nearestWarehouseWithInventory/${productCode}/${destPostalCode}`,
					{
						method: "GET",
						headers: {
							"Content-Type": "application/json",
						},
					}
				);
				if (response.status === 400)
					throw new Error("Error in getting warehouse data");

				const res = await response.json();
				nearestWarehouses = res.warehouses;
                destAddr = res.destAddr?.location
				destinationCoords = res.destAddr?.coords;
				return res;
			}
			else{
				throw new Error("destPostalCode not defined");
			}
		} catch (error) {
			console.error("Fetching shipping rates failed: " + error);
		}
	}

	async function setOriginPostalCode() {
		await updateNearestWarehouses();
		//to do update according to quantity
		let nearestWarehouse = nearestWarehouses.find(warehouse => {
            if(warehouse.stockAvailable >= $quantity)
                return warehouse;
        });
		//if no warehouse satisfy quantity selecting the last warehouse											
		if(!nearestWarehouse) {
			nearestWarehouse = nearestWarehouses[nearestWarehouses.length-1];
		}
        console.log('nearestWarehouse', nearestWarehouse)
        nearestWarehouseAddr = nearestWarehouse?.address;
		origPostalCode = nearestWarehouse.address?.postalOrZipCode;
		nearestWarehouseLat = nearestWarehouse.geo.lat;
		nearestWarehouseLng = nearestWarehouse.geo.lng;
		// console.log("OrigPostalCode: " + origPostalCode + "," + "Quantity: " + $quantity);
	}

	async function getShippingTimelineEstimate() {
		try {
			await setOriginPostalCode();
			const response = await fetch(`/_data/${lang}/delivery/days/${nearestWarehouseLat},${nearestWarehouseLng},${destinationCoords.latitude},${destinationCoords.longitude}?date=${new Date().toISOString()}`,
				{
					method: "GET",
					headers: {
						"Content-Type": "application/json",
					},
				}
			);
			if (response.status === 400) {
				throw new Error('Error in getting shipping timelines');
			}
			const data = await response.json();
			shippingThreshold = data.shippingThreshold;
			estShippingTimeline = data;
			console.log("on page lode estShippingTimeline",estShippingTimeline);      //Testing purpose only
		} catch (error) {
			console.error("Fetching shipping timelines failed: " + error);
		}

	}

	const getShippingRatesandTimeline = async () => {
		try {
			if (
				lang &&
				productCode &&
				$quantity &&
				origPostalCode &&
				destPostalCode &&
                !availabilityData?.codes.includes('BOPIS_ONLY')
			) {
				// let callPaccurateApi = (showPostalUI && !disableShipToHome && $quantity > 1) ? true : false;
                const shippingPayload = {
                    productCode: parseInt(productCode),
                    quantity: parseInt($quantity),
                    price: effectivePrice,
                    nearestWarehouseAddr,
                    destAddr,
                    origPostalCode,
                    destPostalCode
                }


				const response = await fetch(`/_data/${lang}/product/shipping/${window.btoa(JSON.stringify(shippingPayload))}`);
				if (response.status === 400)
					throw new Error("Shipping cost api failed");

				const res = await response.json();
				return res;
			}
		} catch (error) {
			console.error("Fetching shipping rates failed: " + error);
		}
	};

	async function setShippingRatesandTimeline() {
        shippingMsgType = ''
        // let prevMethodValue = $method;
        // if ($method == 'Ship') $method = ''
        disableShipToHome = false
        noRatesReturned = false

        await setOriginPostalCode();
        let shippingResponse = await getShippingRatesandTimeline();

		const elemShipToHome = document.getElementById("shipToHome");


        if(!shippingResponse?.shippingRates && !shippingResponse.hasOwnProperty('isExcludedPostal')) {
            disableShipToHome = true
            noRatesReturned = true
			if (elemShipToHome) {
				elemShipToHome.style.visibility = "hidden";
				elemShipToHome.disabled = true;
			}
            if(availabilityData?.codes.includes('IN_STOCK_ONLINE') && !disableStorePickup ){
                $method = 'Pickup'
            }
            window.dispatchEvent(new CustomEvent('disableaddtocart', {
                detail: {
                    shipStatus: 'success'
                }
            })) 
            return 0
        } else if(!shippingResponse?.isExcludedPostal){
			if (elemShipToHome) {
				elemShipToHome.style.visibility = "visible";
				elemShipToHome.disabled = false;
			}
            if( availabilityData?.codes.includes('SHIP_TO_HOME_ONLY')) {
                $method = 'Ship'
            }else if($method == 'Ship' && availabilityData?.codes.includes('IN_STOCK_ONLINE')) {
                $method = 'Ship'
            }else if($method == 'Pickup' && availabilityData?.codes.includes('IN_STOCK_ONLINE')) {
                $method = 'Pickup'
            }
        }

        if(shippingResponse?.isExcludedPostal && !disableStorePickup) {
            $method = 'Pickup'
        } 
        // if(shippingResponse?.isExcludedPostal){
        //     window.dispatchEvent(new CustomEvent('disableaddtocart', {
        //         detail: {
        //             shipStatus: 'fail'
        //         }
        //     }))
        // } else {
		// window.dispatchEvent(new CustomEvent('disableaddtocart', {
		// 	detail: {
		// 		shipStatus: 'success'
		// 	}
		// }))
        // }

        shippingRates = shippingResponse.shippingRates;
        shippingTimeline = shippingResponse.shippingTimeline;
		bufferTime =  shippingResponse.sthBufferTime;

        shippingThreshold = shippingResponse?.shippingThreshold
        freeShipping = shippingThreshold && (Number(shippingThreshold) < (Number(effectivePrice) * $quantity));
        if(freeShipping && !shippingResponse?.isExcludedPostal && shippingResponse.isOverweightOrOversized && shippingResponse.fragileCharges) {
            freeShipping = false;
            shippingRates = shippingResponse.fragileCharges + shippingResponse.oversizeCharges
        }
        else if(freeShipping && !shippingResponse?.isExcludedPostal && shippingResponse.isOverweightOrOversized) {
            freeShipping = false;
            shippingRates = shippingResponse?.oversizeCharges
        }
        else if(freeShipping && !shippingResponse?.isExcludedPostal && shippingResponse.fragileCharges) {
            freeShipping = false;
            shippingRates = shippingResponse?.fragileCharges;
        }
        // console.log('Free shipping: ', freeShipping)
        if(shippingResponse.isOverweightOrOversized && shippingResponse.fragileCharges){
            shippingMsgType = 'Fragile & Oversize'
            miscShippingCharges = shippingResponse.fragileCharges + shippingResponse.oversizeCharges
        } else if(shippingResponse.isOverweightOrOversized) {
            isOverweightOrOversized = shippingResponse.isOverweightOrOversized
            shippingMsgType = 'Oversize'
            miscShippingCharges = shippingResponse?.oversizeCharges
            
        } else if(shippingResponse.fragileCharges) {
            shippingMsgType = 'Fragile'
            miscShippingCharges = shippingResponse?.fragileCharges
        }
        
        //setting shipping(store variable)
        shipping.set({
            'cost': shippingRates,
            'days': shippingTimeline
        });				

        if (shippingRates) {
            invalidPostalCodeError = false;
        } else {
            //show invalid postal code error
            invalidPostalCodeError = true;
        }

        //check shipTohome is enabled or disabled based on quantity
        if(!disableShipToHome)
        {
            //hide shipToHome radio button if postalcode is in excluded list from kibo
			if (elemShipToHome) {
				elemShipToHome.style.visibility = invalidPostalCodeError ? "hidden" : "visible";
				elemShipToHome.disabled = invalidPostalCodeError;
			}
        }	    
        
	}

	async function onSubmit(e) {
		//show shipping cost loader
		shippingCostLoader = true;
        unAvailPostal = destPostalCode

		changedPostal = true;

		const formData = new FormData(e.target);
		// console.log('Shipping Form Data', formData);
		const data = {};
		for (let field of formData) {
			const [key, value] = field;
			data[key] = value;
		}

		let formInputPostalCode = data.postalCode.trim().split(" ").join("");

		if (!isPostalCodeValid(formInputPostalCode)) {
			invalidPostalCodeError = true;
			invalidPostalCodeFormatError = true;

			//check shipTohome is already disabled based on quantity
			if(!disableShipToHome)
			{
				//hide shipToHome radio button if postalcode is in excluded list from kibo
				document.getElementById("shipToHome").style.visibility = invalidPostalCodeError ? "hidden" : "visible";
				document.getElementById("shipToHome").disabled = invalidPostalCodeError;
			}
            if(availabilityData?.codes.includes('IN_STOCK_ONLINE')){
                $method = 'Pickup'
            }
            
		} else {
			invalidPostalCodeError = false;
			invalidPostalCodeFormatError = false;
			destPostalCode = formInputPostalCode;
            // $method = 'Ship'
			try {
				await setShippingRatesandTimeline();
				// if (!invalidPostalCodeError) {
				// 	//updating preferredPostal cookie and shipping object imported from store.
				// 	// setCookie("preferredPostal", destPostalCode, 99);
				// }
			} catch (error) {
				console.error("Shipping cost api failed: " + error);
			}
		}

        if(invalidPostalCodeError) {
            if(/^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i.test(destPostalCode)){
                setCookie('sthPostalCode', encodeURIComponent(JSON.stringify({
                    postalCode: destPostalCode,
                    status: 'Invalid',
                    setViaPreferredStore: false,
                })), 365)
            }
        } else {
            setCookie('sthPostalCode', encodeURIComponent(JSON.stringify({
                postalCode: destPostalCode,
                status: 'Valid',
                setViaPreferredStore: false,
            })), 365)
        }
		//hide shippingCostLoader
		shippingCostLoader = false;
	}
    async function setSTHCookie() {
        let userCookie = getCookie('user')
        let sthPostalCookie = getCookie('sthPostalCode') 
        if(sthPostalCookie){
            sthPostalCookie =  JSON.parse(sthPostalCookie)
            let postalCode = sthPostalCookie?.postalCode
            destPostalCode = postalCode
            unAvailPostal = postalCode
            // if(sthPostalCookie?.status == 'Valid') return 1
            return 1
        }
        
        if (userCookie) {
            let userData = JSON.parse(userCookie);
            if ( userData && (userData.isAnonymous === 'false' || userData.isAnonymous === false)) {
                let userPrimaryContact = await fetch(`/_data/${lang}/:accountId/contact`, {
                    method: 'POST',
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        accountId: userData?.accountId,
                        defaultStore: preferredStore?.address?.postalOrZipCode
                    })
                })
                userPrimaryContact = await userPrimaryContact.json();
                // console.log('userPrimaryContact', userPrimaryContact);
                destPostalCode = userPrimaryContact?.postalOrZipCode
                setCookie('sthPostalCode', encodeURIComponent(JSON.stringify({
                    postalCode: destPostalCode,
                    status: 'Valid',
                    setViaPreferredStore: false,
                })), 365)
            }else {
                destPostalCode = preferredStore?.address?.postalOrZipCode  
                setCookie('sthPostalCode', encodeURIComponent(JSON.stringify({
                    postalCode: destPostalCode,
                    status: 'Valid',
                    setViaPreferredStore: true,
                })), 365)
            }
        }
    }

	async function setDestPostalCodeAndCalculateShipping() {
		try {
			shippingCostLoader = true;
            // window.dispatchEvent(new CustomEvent('disableaddtocart', {
            //     detail: {
            //         shipStatus: 'fail'
            //     }
            // }))
			destPostalCode = destPostalCode == '' ? getCookie("sthPostalCode") || preferredStorePostalCode : destPostalCode;
            await setSTHCookie()
			if (showPostalUI && $quantity != prevQuantity) {
				await setShippingRatesandTimeline();
				prevQuantity = $quantity;
			} else if (changedPostal) {
				await getShippingTimelineEstimate();
				changedPostal = false;
			}
			shippingCostLoader = false;
		} catch (error) {
			shippingCostLoader = false;
			console.error("Set DestPostalCode and Calculate Shipping rates failed: " + error);
		}
	}

	function formatMoney(amount) {
		return new Intl.NumberFormat(`${lang}-CA`, { style: 'currency', currency: 'CAD' }).format(amount)
	}

	if (availabilityData?.codes.includes('IN_STOCK_ONLINE') || availabilityData?.codes.includes('SHIP_TO_HOME_ONLY')) {
        setDestPostalCodeAndCalculateShipping();
    }
    checkMaxQuanityPerFulfillmentType();


    if(availabilityData?.codes.includes('IN_STOCK_ONLINE') || availabilityData?.codes.includes('BOPIS_ONLY') ) {
        dcFullfillmentTimelines()
    }

	document.querySelector('hh-modal')?.addEventListener('mouseup', (e)=> {
		const container = document.querySelector('hh-modal > div');
		if(container && !container.contains(e.target)){
			showShipToStoreUI = false;
		}
	})

	//updating preferredStorePostalCode variable and calculating shipping cost again on preferred storechange
	window.addEventListener("storechanged",	function (e) {
			prevQuantity = 0;
			updatepreferredStorePostalCode();
			debounce(setDestPostalCodeAndCalculateShipping);
		},
		false
	);

	$: if (availabilityData?.codes.includes('SHIP_TO_HOME_ONLY')) {
		$method = 'Ship';
        disableStorePickup = true
	}

	$: if(destPostalCode) {
		destPostalCode = destPostalCode.toUpperCase()
        let regex = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;
		let isValid = !regex.test(destPostalCode)
		if(destPostalCode.length > 3 && destPostalCode[3] !== ' ' ){
			let x = destPostalCode.split("");
			x.splice(3, 0 , ' ');
			destPostalCode = x.join('')
		}
		
		if(!isValid){
			destPostalCode = destPostalCode.replace(/[^A-Za-z0-9\s]/g, "")
		}

	}
	// let selectedMethod = $method;

	function changeFulfillment(){
        if($method === "Ship")
            {
                document.getElementById("shipToHome") ? document.getElementById("shipToHome").style.visibility = "hidden" : '';
                document.getElementById("shipToHome") ? document.getElementById("shipToHome").disabled = true : '';
                document.getElementById("pickUp") ? document.getElementById("pickUp").checked = true : '';
                disableShipToHome = true;
                $method = "Pickup";
            }
        else if($method === "Pickup")
            {
                document.getElementById("pickUp") ? document.getElementById("pickUp").style.visibility = "hidden" : '';
                document.getElementById("pickUp") ? document.getElementById("pickUp").disabled = true : '';
                document.getElementById("shipToHome") ? document.getElementById("shipToHome").checked = true : '';
                disableStorePickup = true;
                $method = "Ship";
            }
	}

	function enableOrDisableFulfillment(currentFulfillmentType, enable){
		if(($method === "Ship" && currentFulfillmentType) || ($method != "Ship" && !currentFulfillmentType)) {
			document.getElementById("shipToHome") ? (document.getElementById("shipToHome").style.visibility = enable ? "visible" : "hidden") : "";
			// document.getElementById("shipToHome") ? document.getElementById("shipToHome").disabled = !enable : "";
			disableShipToHome = !enable;
		}
		
		if(($method === "Pickup" && currentFulfillmentType) || ($method != "Pickup" && !currentFulfillmentType))
		{
			document.getElementById("pickUp") ? (document.getElementById("pickUp").style.visibility = enable ? "visible" : "hidden") : "";
			document.getElementById("pickUp") ? document.getElementById("pickUp").disabled = !enable : "";
			disableStorePickup = !enable;			
		}
	}

	function checkMaxQuanityPerFulfillmentType(){
		// if(!availabilityData?.codes.includes('IN_STOCK_ONLINE')) return 0;

		//quanity for selected fulfillment and other fulFillment type

        // if(!$method ) return 0

		fulFillmentTypeQuantity = ($method === "Pickup") ? availabilityData?.maxQtyBopis : (($method === "Ship") ?  availabilityData.maxQtySth : 0);
		otherFulFillmentTypeQuantity = ($method === "Pickup") ? availabilityData?.maxQtySth : (($method === "Ship") ?  availabilityData.maxQtyBopis : 0);
		
		// console.log("SelectedfulFillmentTypeQuantity: "  + fulFillmentTypeQuantity);
		// console.log("otherFulFillmentTypeQuantity: "  + otherFulFillmentTypeQuantity);

		//change fulfillment if quanity increases selected fulFillment
		if((fulFillmentTypeQuantity < $quantity) && (otherFulFillmentTypeQuantity >= $quantity)){
			
			changeFulfillment();
			fulFillmentTypeQuantity = ($method === "Pickup") ? availabilityData?.maxQtyBopis : (($method === "Ship") ?  availabilityData.maxQtySth : 0);
			otherFulFillmentTypeQuantity = ($method === "Pickup") ? availabilityData?.maxQtySth : (($method === "Ship") ?  availabilityData.maxQtyBopis : 0);
								
		}


		(fulFillmentTypeQuantity >= $quantity) ? enableOrDisableFulfillment(true, true) : enableOrDisableFulfillment(true, false);
		(otherFulFillmentTypeQuantity >= $quantity) ? enableOrDisableFulfillment(false, true) : enableOrDisableFulfillment(false, false);

		// console.log("FulFillment method Selected: " + $method);
	}

	function shouldShowLowStockMessage(data) {
		let codes = data?.codes || [];
		let hasPickup = codes?.includes('IN_STOCK_ONLINE') || codes?.includes('BOPIS_ONLY');
		let hasShipToHome = codes?.includes('IN_STOCK_ONLINE') || codes?.includes('SHIP_TO_HOME_ONLY');

		let storeStock = data?.inventory?.store ?? 0;
		let warehouseStock = data?.inventory?.warehouse ?? 0;
		let sthStock = data?.inventory?.sth ?? 0;
		let combinedStock = storeStock + warehouseStock;

		if (hasPickup && hasShipToHome && combinedStock < 16 && sthStock < 30) return true;
		if (hasPickup && !hasShipToHome && combinedStock < 16) return true;
		if (!hasPickup && hasShipToHome && sthStock < 30) return true;

		return false;
	}

	if(availabilityData){
		lowStockWarning = shouldShowLowStockMessage(availabilityData);
	}

</script>

<div class="shippingContainer">
	{#if !availabilityData?.debug?.isOnlineClearence}
		{#if availabilityData?.debug?.storeNRTI}
			<p>
				{#if !onlineOnlyProduct}
					<span data-stock-count="{ availabilityData?.inventory?.store >= 0 ? availabilityData?.inventory?.store : 0}">
						{ (availabilityData?.inventory?.store <= 500) ? availabilityData?.inventory?.store >= 0 ? availabilityData?.inventory?.store : 0 : '500+' } {_strings.availableAt}
					</span>
					{_strings.inStoreAt}
				{/if}
				<b>{preferredStore.name}</b>
			</p>
			<a href="/product-locator" on:click|preventDefault={()=>openProductLocator(productCode, productName, productBrand)}>{_strings.checkStoreAvailability}</a>
		{:else}
			<p>
				<span>{@html `<strong> ${preferredStore.name} ${preferredStore?.phone || ''}</strong>`}</span> <br>
				<span data-stock-count>{lang == 'en' ? 'Call for in-store availability' : 'Appelez pour connaître la disponibilité en magasin'}</span>
			</p>
		{/if}
	{/if}
	

	<h3>{_strings.shippingOptions}</h3>

	{#if lowStockWarning }
			<p class="low-stock-messaging">
				<img src="https://homehardware.sirv.com/hh/icons/Icon_RedExclamation.svg" alt="Exclamation" width="20" height="20"/>
				<span>{lang == 'en' ? `Low stock! Order now to avoid disappointment.`: `Stocks faibles! Commandez maintenant pour éviter une déception.`}</span>
			</p>
	{/if}

	<form class="Form" on:submit|preventDefault>
		<fieldset>
			{#if availabilityData?.codes.includes('IN_STOCK_ONLINE') || availabilityData?.codes.includes('BOPIS_ONLY')}
			<label class="Radio">
				<input type="radio" id="pickUp" bind:group={$method} name="fulfillmentOption" value="Pickup" checked={$method === 'Pickup'}/>
				<div>
					<img src="https://homehardware.sirv.com/hh/icons/icon-home.store.svg" alt="" width="25" height="20">
					<p>
						<span>{ availabilityData.debug.isEcommerceItem ? _strings.freeShipToStore : _strings.freeInStorePickup}</span>
                        {#if fetchTimelineLoader}
                            <!-- show nothing-->
						{:else if !disableStorePickup && fetchPickupTimelines}
							{#if availabilityData?.inventory?.warehouse == 0 && availabilityData?.inventory?.store > 0 }
								<span data-stock-count="{availabilityData?.inventory?.store || 0}">{_strings.available}</span>
							{:else}
								<span data-stock-count="{ availabilityData?.inventory?.warehouse >= 0 ? availabilityData?.inventory?.warehouse : 0}">
                    			{ (availabilityData?.inventory?.warehouse <= 500) ? availabilityData?.inventory?.warehouse >= 0 ? availabilityData?.inventory?.warehouse : 0 : '500+' } {_strings.available}
               					</span>
							{/if}
							{#if fetchPickupTimelines?.Flags.infrequentDeliveries}
								<span class="shippingEstimate" on:click|preventDefault={toggleShipToStoreUI}>{_strings.arrivalMessage(fetchPickupTimelines?.Least, fetchPickupTimelines?.Most)} <img src="https://homehardware.sirv.com/hh/icons/icon-info.svg" alt=""/></span>
								{#if showShipToStoreUI}
									<Portal target='hh-modal'>
										<section class="shipToHomePortalTitle">
											<img src="https://homehardware.sirv.com/hh/icons/icon-shipping-truck.svg" alt="">
											<span class="h4">{_strings.increasedShippingTimeline}</span>
										</section>
										<section class="shipToHomePortalBody">
											<hr />
											<span>{_strings.increasedShippingTimelineContent}</span>
											<hr />
											<button class="Button ButtonSecondary" on:click={toggleShipToStoreUI}>{_strings.closeBtn}</button>
										</section>
									</Portal>
								{/if}
							{:else}
								<span>{_strings.arrivalMessage(fetchPickupTimelines?.Least, fetchPickupTimelines?.Most)}</span>
							{/if}
						{:else}
							<span>
								<img class="cross-sign" src="https://homehardware.sirv.com/hh/icons/icon-x.red.svg" alt="" width="18" height="16">
								{_strings.only} {availabilityData?.maxQtyBopis} {_strings.available}
							</span>
						{/if}
					</p>
				</div>
			</label>
			{/if}
			{#if availabilityData?.codes.includes('IN_STOCK_ONLINE') || availabilityData?.codes.includes('SHIP_TO_HOME_ONLY')}

			<label class="Radio" data-shipping-status={shippingStatus} data-shipping-timeline= { !showPostalUI ? `${estShippingTimeline.min}-${estShippingTimeline.max}` : !invalidPostalCodeError && shippingTimeline === 'default' ? '3-4' : !invalidPostalCodeError && shippingStatus !== "No Rates" ? `${shippingTimeline}-${shippingTimeline + 2 + bufferTime}` : ''}>

				<input type="radio" id="shipToHome" bind:group={$method} name="fulfillmentOption" value="Ship" checked={$method === 'Ship'} disabled={ disableShipToHome || invalidPostalCodeError}/>
					<div>
						<img src="https://homehardware.sirv.com/hh/icons/icon-shipping-truck.svg" alt="" width="25" height="23">
						<p>
							<span>{_strings.shipToHome}</span>
							{#if !disableShipToHome}
								<span>
                                    {#if shippingCostLoader}
                                        <span> {_strings.checkRatesLoading} </span>
										&nbsp;
									{:else if !showPostalUI}
										<span data-stock-count="{ availabilityData?.inventory?.sth >= 0 ? availabilityData?.inventory?.sth : 0}">
											{ (availabilityData?.inventory?.sth <= 500) ? availabilityData?.inventory?.sth >= 0 ? availabilityData?.inventory?.sth : 0 : '500+' } {_strings.available}
										</span>
										{#if estShippingTimeline.min && estShippingTimeline.max}
											{_strings.arrives} {estShippingTimeline.min}{_strings.hyphen}{estShippingTimeline.max} {_strings.days}
										{/if}
                                    {:else if shippingTimeline == 'default' && shippingRates}
										<span data-stock-count="{ availabilityData?.inventory?.sth >= 0 ? availabilityData?.inventory?.sth : 0}">
											{ (availabilityData?.inventory?.sth <= 500) ? availabilityData?.inventory?.sth >= 0 ? availabilityData?.inventory?.sth : 0 : '500+' } {_strings.available}
										</span>
                                        	{_strings.arrives} 3{_strings.hyphen}{4 + bufferTime} {_strings.days}
									{:else if !invalidPostalCodeError && shippingRates}
											<span data-stock-count="{ availabilityData?.inventory?.sth >= 0 ? availabilityData?.inventory?.sth : 0}">
												{ (availabilityData?.inventory?.sth <= 500) ? availabilityData?.inventory?.sth >= 0 ? availabilityData?.inventory?.sth : 0 : '500+' } {_strings.available}
											</span>
										    {_strings.arrives} {shippingTimeline}{_strings.hyphen}{shippingTimeline + 2 + bufferTime} {_strings.days}
									{:else if showPostalUI}
										<span> {_strings.checkRatesLoading} </span>
										&nbsp;
									{:else}
											{_strings.shippingUnavailable} {unAvailPostal}
									{/if}
								</span>
								<span on:click|preventDefault={togglePostalUI} class="h4 shippingEstimate estimated-shipping-underline">{_strings.shippingCost} <img src="https://homehardware.sirv.com/hh/icons/icon-info.svg" alt=""/></span>
                            {:else if noRatesReturned}
                                 <span>
                                    <img class="cross-sign" src="https://homehardware.sirv.com/hh/icons/icon-x.red.svg" alt="" width="18" height="16">
                                    {_strings.noRatesReturned}
                                 </span>
							{:else}
								<span>
									<img class="cross-sign" src="https://homehardware.sirv.com/hh/icons/icon-x.red.svg" alt="" width="18" height="16">
									{_strings.only} {availabilityData?.maxQtySth} {_strings.available}
								</span>
							{/if}
						</p>
						
					</div>
			</label>
			{/if}
		</fieldset>
		
		{#if showPostalUI && !disableShipToHome}
			<div class="shipping">
				<hr class="top-margin-zero"/>
                <form class="Form" on:submit|preventDefault={onSubmit}>
                    <label for="postalCode" class="h4 Light margin-bottom-postal-question {shippingCostLoader === true ? 'disable' : ''}">{_strings.postalCodeQuestion}</label>
                    <fieldset class="FormFlex padding-margin-bottom-zero row-gap-zero{shippingCostLoader === true ? 'disable' : ''}"> 
                            <input type="text" class="postal-input margin-bottom-update-button" maxlength="7"	id="postalCode"	name="postalCode" bind:value={destPostalCode}/>
                            <button class="Button ButtonSecondary margin-bottom-update-button" type="submit">
                                <b>{_strings.update}</b>
                            </button>
                    </fieldset>
    
                    {#if shippingCostLoader}
                        <div>
                                
                            <span class="h4 Light">
                                {_strings.findingRates}
                            </span>
                        
                            <div class="lds-ellipsis">
                                <div />
                                <div />
                                <div />
                                <div />
                            </div>
                        </div>
                        <fieldset></fieldset>
					{:else if invalidPostalCodeFormatError}
                        <fieldset>
                            <p class="h4 Light invalid-postal-error">{_strings.invalidPostalCodeFormatMsg}</p>
                        </fieldset>	
					{:else if invalidPostalCodeError}
                        <fieldset>
                            <p class="h4 Light invalid-postal-error">{_strings.invalidPostalCodeMsg}</p>
                        </fieldset>	
                    {:else if shippingRates}
                        <fieldset class="padding-margin-bottom-zero">
                            <!-- svelte-ignore a11y-label-has-associated-control -->
                            <label class="h4 Light">
                                {_strings.estimateShippingCost}
                                <strong>{freeShipping ? _strings.freeMsg : formatMoney(shippingRates)}</strong>
                            </label>
                        </fieldset>

                        {#if shippingMsgType === 'Fragile & Oversize'}
                            <fieldset class="padding-margin-bottom-zero">
                                <!-- svelte-ignore a11y-label-has-associated-control -->
                                <label class="h5 Light shippo-msg-color">
                                    {_strings.fragileOverweightMessage(formatMoney(miscShippingCharges))}
                                    <a	href={`/${lang}/help-and-support`}	target="_blank"	class="faq-link">
                                        {_strings.faqPage}
                                    </a>
                                </label>
                            </fieldset>
                        {:else if  shippingMsgType === 'Oversize'}
                            <fieldset class="padding-margin-bottom-zero">
                                <!-- svelte-ignore a11y-label-has-associated-control -->
                                <label class="h5 Light shippo-msg-color">
                                    {_strings.overweightMessage(formatMoney(miscShippingCharges))}
                                    <a	href={`/${lang}/help-and-support`}	target="_blank"	class="faq-link">
                                        {_strings.faqPage}
                                    </a>
                                </label>
                            </fieldset>
                        {:else if  shippingMsgType === 'Fragile'}
                            <fieldset class="padding-margin-bottom-zero">
                                <!-- svelte-ignore a11y-label-has-associated-control -->
                                <label class="h5 Light shippo-msg-color">
                                    {_strings.fragileMessage(formatMoney(miscShippingCharges))}
                                    <a	href={`/${lang}/help-and-support`}	target="_blank"	class="faq-link">
                                        {_strings.faqPage}
                                    </a>
                                </label>
                            </fieldset>                                
                        {/if}
                        
                    {/if}
                </form>
                <hr class="margin-bottom-postal-question"/>
                <form class="Form top-margin-zero">
                    <fieldset>
                        <p class="shippo-modal-footer">
                            <span>
                                {_strings.footerShippingEstimationBoxMessageLine1}<br />
                            </span>
                            <span>
                                {_strings.footerShippingEstimationBoxMessageLine2}
                            </span>
                            <!-- {#if shippingThreshold}
                                    <br />
                                    <span>
                                    {_strings.freeShipMsgGenerate(shippingThreshold)}
                                    </span>
                            {/if} -->
                        </p>
                    </fieldset>
                </form>
            </div>
        {/if}
        {#if shippingThreshold}
            <div class="free-shipping-messaging">
                {@html dataset?.freeShippingMessage }
            </div>

        {/if}
		
	</form>
	

	
	
	<!-- <pre>
	Shipping based on quantity of {$quantity}
	showPostalUI: {showPostalUI}
	</pre> -->
</div>


<style>

	.shippingContainer p {
		font-family: 'hhAgendaMedium', 'sans-serif';
		font-size: 1.125rem;
	}
	.shippingContainer p:nth-child(1){
		padding-top: 0 ;
		padding-bottom: 0 ;
	}
	.shippingContainer a:nth-child(2){
		color: #54585A;
		text-decoration: underline;
	}
	.shippingContainer h3 {
		margin-top: 1rem;
	}
	.shippingContainer p a {
		text-decoration: underline;
		text-underline-position: under;
		font-family: 'hhAgendaBold', 'sans-serif';
	}
	.shippingContainer form {
		margin-top: 0.75rem;
	}
	form fieldset label:first-child {
		margin-bottom: 1.125rem;
	}

	form fieldset > label.Radio {
		display: grid;
		grid-template-columns: 1fr 20fr;
		grid-column-gap: 0.625rem;
	}
	form input[name = "fulfillmentOption"] {
		margin-top: 0.625rem;
		align-self: self-start;
	}
	form input[name = "fulfillmentOption"] + div {
		width: 90%;
		display: inline-grid;
		grid-template-columns: 1fr 9fr;
		grid-column-gap: 0.625rem;
	}
	form input[name = "fulfillmentOption"] + div > img {
		justify-self: center;
		margin-top: 5px;
	}
	form input[name = "fulfillmentOption"] + div > p {
		line-height: 1;
		margin: 0;
		padding: 0;
		font-size: 1.125rem;
	}
	form input[name = "fulfillmentOption"] + div > p span {
		display: block;
		line-height: 1.5;
	}
	form input[name = "fulfillmentOption"] + div > p span:not(:first-child) {
		font-size: 0.875rem;
	}
	form input[name = "fulfillmentOption"] + div > p span.shippingEstimate {
		cursor: pointer;
	}
	:global(span[data-stock-count]) {
		color: var(--hh-green)
	}
	:global(span[data-stock-count="0"]) {
		color: var(--hh-red)
	}
    .low-stock-messaging{
        font-size: 1rem !important;
        padding: 0.5em 0;
        color: var(--hh-red);
        display: flex;
    }
    .low-stock-messaging > span {
        margin-left: 5px;
    }

	.shipToHomePortalTitle {
		display: flex;
		justify-content: center;
		margin-top: calc(var(--gap) / 2);
	}
	.shipToHomePortalTitle span {
		margin-top: auto;
	}
	.shipToHomePortalTitle img {
		width: 1.5em;
		margin-right: calc(var(--gap) / 2);
	}
	.shipToHomePortalBody {
		text-align: center;
	}
	.shipToHomePortalBody hr {
		width: 100%;
	}
	.shipToHomePortalBody button {
		padding: 0.55em 4em;
	}

	.cross-sign {
		float: left;
		margin-right: 0.5em;
	}

	/* .margin-left{
		margin-left: 5em;
	} */

	.margin-bottom-postal-question {
		margin-bottom: 0.7em;
	}

	hr.margin-bottom-postal-question {
		margin-top: 0;
	}
	
	.margin-zero {
		margin: 0;
	}

	.top-margin-zero {
		margin-top: 0 !important;
	}

	@media (max-width: 1100px) {
		/* .margin-left{
			margin-left: 4.2em;
		}	 */
	}	

	.padding-margin-bottom-zero {
		padding-bottom: 0;
    	margin-bottom: 0;
	}

	.row-gap-zero {
		row-gap: 0;
	}

	.margin-bottom-update-button {
		margin-bottom: 22px;
	}

	.postal-input {
		width: 11em;
        flex-grow: 1;
	}

	.free-shipping-messaging,
    .shippo-modal-footer {
		line-height: 16.8px;
   		font-size: 14px !important;
	}
    .free-shipping-messaging {
        padding-bottom: 0.5rem;
    }
    :global(.free-shipping-messaging > *) {
        padding-top: 0
    }
    :global(.free-shipping-messaging > *:not(:last-child)) {
        padding-bottom: 0
    }

	.shippo-msg-color {
		color: #54585A;
        line-height: 18px;
	}

	.invalid-postal-error {
		color: #D6001B
	}
	.shipping {
        padding-right: 0.25rem;
	}

    .shipping > form:last-child > fieldset:last-child {
        padding-bottom: 0;
    }

	.faq-link{
		color: #e4002b;
        text-decoration: underline;
        text-underline-position: under;
	}

	.estimated-shipping-underline {
		text-decoration: underline;
    	text-underline-position: under;
	}

	.disable {
		opacity: 0.4;
	}

	.lds-ellipsis {
		display: inline-block;
		position: relative;
		width: 64px;
		height: 0.7em;
	}
	.lds-ellipsis div {
		position: absolute;
		width: 11px;
		height: 0.7em;
		border-radius: 50%;
		background: #000000;
		animation-timing-function: cubic-bezier(0, 1, 1, 0);
	}
	.lds-ellipsis div:nth-child(1) {
		left: 6px;
		animation: lds-ellipsis1 0.6s infinite;
	}
	.lds-ellipsis div:nth-child(2) {
		left: 6px;
		animation: lds-ellipsis2 0.6s infinite;
	}
	.lds-ellipsis div:nth-child(3) {
		left: 26px;
		animation: lds-ellipsis2 0.6s infinite;
	}
	.lds-ellipsis div:nth-child(4) {
		left: 45px;
		animation: lds-ellipsis3 0.6s infinite;
	}
	@keyframes lds-ellipsis1 {
		0% {
			transform: scale(0);
		}
		100% {
			transform: scale(1);
		}
	}
	@keyframes lds-ellipsis3 {
		0% {
			transform: scale(1);
		}
		100% {
			transform: scale(0);
		}
	}
	@keyframes lds-ellipsis2 {
		0% {
			transform: translate(0, 0);
		}
		100% {
			transform: translate(19px, 0);
		}
	}

	@media (max-width: 600px) {
		form input[name = "fulfillmentOption"] + div {
			width: 100%;		
		}
		form input[name = "fulfillmentOption"] + div > p span:not(:first-child),
		.shippo-modal-footer span {
			font-size: 1rem;
		}
		form input[name = "fulfillmentOption"] + div > p,
		.shippingContainer p {
			font-size: 1.15rem;
		}
        /* .margin-left {
            margin-left: 0;
        }			 */
	}
	
</style>